import { atom } from "jotai";

// 게임 종료 상태값
export const endStateAtom = atom(false);

// 게임 종료시 점수
export const scoreAtom = atom<number>(0);

// 게임 종료시 획득한 별
export const newStarCountAtom = atom<number>(0);
